import React from 'react';
import { connect } from 'react-redux';
import ConfirmComponent from '../../confirm-component';
import { updateUser } from '../../../user/actions';
import { getUsers } from '../../actions';

// Create an editable cell renderer
const UserEnabledCell = ({
  cell: { value: initialValue },
  data: user,
  dispatch
}) => {
  // We need to keep and update the state of the cell normally
  const [value, setValue] = React.useState(initialValue);
  const [modalOpen, setModalOpen] = React.useState(false);
  // If the initialValue is changed externall, sync it up with our state
  React.useEffect(() => {
    setValue(initialValue)
  }, [initialValue])

  function disableUser() {
    user.isActive = !user.isActive;
    dispatch(updateUser(user, false));
    setTimeout(() => {
      dispatch(getUsers());
      setModalOpen(false);
    }, 500);
  }

  let activeMessage = user.isActive ?
    'Are you sure you want to disable this user? This will prevent the user account from logging in or accessing portions of the site requiring an account.' :
    'Are you sure you want to enable this user? This will allow the user to log in and access portions of the site requiring an account.';

  return <div>
    <div className="toggle-active">
      <label htmlFor={`${user._id}.isActive`} className="switch" onClick={() => { setModalOpen(true) }} >
        <input name={`${user._id}.isActive`} readOnly={true} type="checkbox" checked={value} />
        <span className="slider round"></span>
      </label>
    </div>
    {modalOpen &&
      (<ConfirmComponent text={activeMessage} onSubmit={disableUser} onClose={() => { setModalOpen(false) }} />)
    }
  </div>
}
export default connect()(UserEnabledCell);
